// libs
import React from 'react';
import cx from 'classnames';
// utils
import { getCloudinaryUrl } from '@/helpers/cloudinary';
// styles
import style from './ProductDetails.module.scss';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import { Svg16 as CloseIcon } from '@swiggy-private/dls-web-icons/dist/web/generic/close';
import PlayIcon from '@swiggy-private/dls-web-icons/dist/web/media/Play';
import { GenericIcon } from '@swiggy-private/dls-web-icons/dist/GenericIconWeb';
// widgets
import RecentlyAddedTag from '@/widgets/RecentlyAddedTag';
const ProductDetails = ({ creativeId, title, subTitle, onDelete, showDelete, expandable, asVariant, variants, onExpand, onCollapse, showRecentlyAddedBadge, }) => {
    const [isExpanded, setIsExpanded] = React.useState(false);
    const toggleExpand = () => {
        isExpanded ? onCollapse === null || onCollapse === void 0 ? void 0 : onCollapse() : onExpand === null || onExpand === void 0 ? void 0 : onExpand();
        setIsExpanded(!isExpanded);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: style.outerContainer },
            showRecentlyAddedBadge && React.createElement(RecentlyAddedTag, null),
            React.createElement("div", { className: cx(style.container, {
                    [style.containerWithPadding]: !expandable && !asVariant,
                }) },
                React.createElement("div", { className: style.imageContainer },
                    React.createElement("img", { src: getCloudinaryUrl(creativeId, {
                            width: 88,
                            height: 88,
                        }), className: style.image })),
                React.createElement("div", { className: cx(style.labels, {
                        [style.labelsExpandable]: expandable,
                    }) },
                    title && (React.createElement(Text, { variant: DlsFontVariants.body_B1_Med, color: DlsColorTokens.text_Highest_Emphasis, maxLines: 2 }, title)),
                    React.createElement("div", { className: style.secondLine }, expandable && (variants === null || variants === void 0 ? void 0 : variants.length) ? (React.createElement("button", { onClick: toggleExpand, className: style.expandableButton },
                        React.createElement(Text, { variant: DlsFontVariants.body_B2_Med, color: DlsColorTokens.text_Low_Emphasis, className: style.secondLineText }, subTitle),
                        React.createElement(PlayIcon, { className: cx(style.expandableButtonIcon, {
                                [style.expandableButtonIconRotated]: isExpanded,
                            }), fill: "black", height: 16, width: 16 }))) : (React.createElement(Text, { variant: DlsFontVariants.body_B2_Med, color: DlsColorTokens.text_Low_Emphasis, className: style.secondLineText }, subTitle)))),
                showDelete && (React.createElement("div", { className: style.deleteIcon },
                    React.createElement("span", { onClick: () => onDelete === null || onDelete === void 0 ? void 0 : onDelete() },
                        React.createElement(GenericIcon, { Icon: CloseIcon, fillColor: DlsColorTokens.text_Low_Emphasis }))))))));
};
export default ProductDetails;
